// extracted by mini-css-extract-plugin
export default {"title-section":"Xj_ldddd3S","titleSection":"Xj_ldddd3S"};